import React from "react"

import { Button } from "~/components"
import { Container, Icons, Card, Title, Content } from "./styles"

const icons = {
  casa: require("~/assets/images/icon-casa.png"),
  auto: require("~/assets/images/icon-auto.png"),
}

export default function PlanBox({
  icon,
  title,
  children,
  onClick,
  dataGtmName,
}) {
  return (
    <Container>
      <Icons>
        <img src={icons[icon] || icons.casa} alt="muda isso depois" />
      </Icons>
      <Card>
        <Title>{title}</Title>
        <Content>{children}</Content>

        {dataGtmName ? (
          <Button
            size="full"
            onClick={onClick}
            data-gtm-type="click"
            data-gtm-clicktype="button"
            data-gtm-name={dataGtmName}
          >
            Solicitar Serviço
          </Button>
        ) : (
          <Button size="full" onClick={onClick}>
            Solicitar Serviço
          </Button>
        )}
      </Card>
    </Container>
  )
}
